<template>
  <main>
    <div class="relative w-full lg:h-[70vh] h-[30vh]">
      <!-- Background Image -->
      <div class="absolute inset-0 overflow-hidden">
        <img
          src="../assets/images/HERO Pages ALL 2.png"
          alt="Background"
          class="w-full h-full object-cover"
        />
        <div class="absolute inset-0 bg-black opacity-50"></div>
      </div>

      <!-- Content Wrapper -->
      <div
        class="relative max-w-screen-4xl mx-auto h-full flex flex-col lg:flex-row items-center justify-center px-6 lg:px-32"
      >
        <h2
          class="text-white text-center text-3xl font-black animate__animated animate__backInLeft"
        >
          Application Form
        </h2>
      </div>

      <!-- SVG Curve (Aligned to Background) -->
      <svg viewBox="0 0 1440 320" class="absolute bottom-0 left-0 w-full">
        <path
          fill="#ffffff"
          d="M0,224L80,208C160,192,320,160,480,176C640,192,800,256,960,266.7C1120,277,1280,235,1360,213.3L1440,192V320H0Z"
        ></path>
      </svg>
    </div>

    <!-- Job registration form -->
    <div class="py-12 px-6">
      <div class="container max-w-3xl mx-auto">
        <!-- Application Form Image -->
        <div class="mb-6">
          <img
            src="../assets/images/application.png"
            alt="Application Form"
            class="w-full"
          />
        </div>
        <!-- Application Form Header -->
        <div class="mb-8 text-center">
          <h2 class="text-3xl font-extrabold text-gray-800">Job Application</h2>
          <p class="text-gray-600">
            Fill out the form below to apply for the position
          </p>
        </div>

        <!-- Form Card -->
        <div class="bg-white rounded-lg shadow-lg p-8">
          <form class="space-y-6">
            <!-- Name Fields -->
            <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label for="firstName" class="block text-gray-700 font-medium"
                  >First Name</label
                >
                <input
                  type="text"
                  id="firstName"
                  placeholder="John"
                  class="w-full mt-1 p-3 border rounded-lg focus:ring-2 focus:ring-blue-500"
                />
              </div>
              <div>
                <label for="lastName" class="block text-gray-700 font-medium"
                  >Last Name</label
                >
                <input
                  type="text"
                  id="lastName"
                  placeholder="Doe"
                  class="w-full mt-1 p-3 border rounded-lg focus:ring-2 focus:ring-blue-500"
                />
              </div>
            </div>

            <!-- Contact Fields -->
            <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label for="email" class="block text-gray-700 font-medium"
                  >Email</label
                >
                <input
                  type="email"
                  id="email"
                  placeholder="you@example.com"
                  class="w-full mt-1 p-3 border rounded-lg focus:ring-2 focus:ring-blue-500"
                />
              </div>
              <div>
                <label for="phoneNumber" class="block text-gray-700 font-medium"
                  >Phone Number</label
                >
                <input
                  type="tel"
                  id="phoneNumber"
                  placeholder="+234 8012345678"
                  class="w-full mt-1 p-3 border rounded-lg focus:ring-2 focus:ring-blue-500"
                />
              </div>
            </div>

            <!-- Address Field -->
            <div>
              <label for="address" class="block text-gray-700 font-medium"
                >Address</label
              >
              <input
                type="text"
                id="address"
                placeholder="Enter your address"
                class="w-full mt-1 p-3 border rounded-lg focus:ring-2 focus:ring-blue-500"
              />
            </div>

            <!-- File Upload Fields -->
            <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label class="block text-gray-700 font-medium"
                  >Attach Resume/CV</label
                >
                <input
                  type="file"
                  id="resume"
                  class="w-full mt-1 p-3 border rounded-lg focus:ring-2 focus:ring-blue-500"
                />
              </div>
              <div>
                <label class="block text-gray-700 font-medium"
                  >Attach Cover Letter</label
                >
                <input
                  type="file"
                  id="coverLetter"
                  class="w-full mt-1 p-3 border rounded-lg"
                />
              </div>
            </div>

            <!-- Submit Button -->
            <div class="text-center py-10">
              <button
                type="submit"
                class="bg-yellow text-black px-6 py-3 rounded-lg hover:bg-blue-700 transition"
              >
                Apply Now
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {};
</script>

<style scoped>
svg path {
  fill: #ffffff !important;
  stroke: none !important;
  box-shadow: none !important;
}

svg {
  overflow: hidden !important;
}

.absolute.bottom-0 {
  line-height: 0 !important;
  padding-bottom: 0 !important;
  margin-bottom: -2px;
}

.overflow-hidden {
  overflow: hidden !important;
}

.who-style {
  font-family: Montserrat;
}

.strategic-card {
  opacity: 0;
  transform: translateY(50px);
  transition: opacity 1s ease-out, transform 1s ease-out;
  will-change: opacity, transform;
}

.strategic-card.fade-in {
  opacity: 1;
  transform: translateY(0);
}

.strategic-card:hover {
  transform: scale(1.03);
  /* box-shadow: 0 15px 30px rgba(0, 0, 0, 0.2); */
  transition: transform 0.4s ease-out, box-shadow 0.4s ease-out;
  /* background-color: inherit !important; */
  box-shadow: none !important;
}

.fade-section {
  opacity: 0;
  transform: translateY(50px);
  transition: opacity 1s ease-out, transform 1s ease-out;
}
.fade-section.fade-in {
  opacity: 1;
  transform: translateY(0);
}
</style>
